export const PRODUCT_FILTER_FIELD_ID = 'product';
export const CONTRACT_STATUS_FILTER_FIELD_ID = 'contractStatus';

export const COMMON_FILTER_FIELD_IDS = Object.freeze({
  Customer: 'customerId',
  Country: 'country',
  State: 'state',
  Labels: 'labels',
  Product: PRODUCT_FILTER_FIELD_ID,
  Plan: 'plan',
  ContractStatus: CONTRACT_STATUS_FILTER_FIELD_ID,
  ContractStartDate: 'contractStartDate',
});
